import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";  

const Features = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
    
    useEffect(() => {
      loadLanguageFile("Features", "feature/feature_body_lang");
    }, [language]);
    const LANGUAGE = componentLanguageData.Features || { Main: {} };
  const features = [
    {
      title: LANGUAGE.Main.Content1,
      description:
      LANGUAGE.Main.Content2,
      delay: '0.2s',
    },
    {
      title: LANGUAGE.Main.Content3,
      description:
      LANGUAGE.Main.Content4,
      delay: '0.4s',
    },
    {
      title: LANGUAGE.Main.Content5,
      description:
      LANGUAGE.Main.Content6,
      delay: '0.6s',
    },
    {
      title: LANGUAGE.Main.Content7,
      description:
      LANGUAGE.Main.Content8,
      delay: '0.8s',
    },
    {
      title: LANGUAGE.Main.Content9,
      description:
      LANGUAGE.Main.Content10,
      delay: '1.0s',
    },
    {
      title: LANGUAGE.Main.Content11,
      description:
      LANGUAGE.Main.Content12,
      delay: '1.2s',
    },
  ];

  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{
        visibility: 'visible',
        animationDelay: '0.1s',
        animationName: 'fadeInUp',
      }}
    >
      <div className="container py-5">
        <div
          className="section-title text-center position-relative pb-3 mb-5 mx-auto"
          style={{ maxWidth: '600px' }}
        >
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content13}</h5>
          <h1 className="mb-0">
          {LANGUAGE.Main.Content14}
          </h1>
        </div>
        <div className="row g-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="col-lg-6 wow zoomIn"
              data-wow-delay={feature.delay}
              style={{
                visibility: 'visible',
                animationDelay: feature.delay,
                animationName: 'zoomIn',
              }}
            >
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
